import React from 'react';

import Box from '@mui/material/Box';

const GroupedParameters = ({ children }) => (
  <Box
    sx={{
      margin: '10px',
      border: '1px solid lightgrey',
      p: 1,
      ob: 0,
      borderRadius: '3px',
    }}
  >
    {children}
  </Box>
);

export default GroupedParameters;
